import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=4297bce5"
import script from "./LanguageChooser.vue?vue&type=script&lang=js"
export * from "./LanguageChooser.vue?vue&type=script&lang=js"
import style0 from "./LanguageChooser.vue?vue&type=style&index=0&id=4297bce5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports